import { NuxtAxiosInstance } from '@nuxtjs/axios'
import processError from '~/helpers/processError'
import { CRMProductHistoryAnalyticsRepo, HistoryApiQueryParams } from '~/types'

export default (
  $axios: NuxtAxiosInstance,
  $sentry: any
): CRMProductHistoryAnalyticsRepo => ({
  async fetchProductHistory(params: HistoryApiQueryParams) {
    try {
      const res = await $axios.get(`/crm/product_history`, {
        params,
      })
      if (res.status === 200) {
        return res.data
      }
    } catch (error) {
      processError(error, $sentry)
    }
  },
  async fetchProductCategoryHistory(params: HistoryApiQueryParams) {
    try {
      const res = await $axios.get(`/crm/product_categories_history`, {
        params,
      })
      if (res.status === 200) {
        return res.data
      }
    } catch (error) {
      processError(error, $sentry)
    }
  },
})
